/**
 * ListPanel organism: header (title, count), search, action slot, scrollable table.
 * Pure layout—action and rows injected via props.
 */

import React from "react";
import { Typography } from "../../atoms/Typography";
import { Table, TableBody } from "../../atoms/Table";
import { SearchInput } from "../../search-input";
import type { ListPanelProps } from "./ListPanel.types";

export const ListPanel: React.FC<ListPanelProps> = ({
  title,
  count,
  searchValue,
  onSearchChange,
  action,
  children,
}) => {
  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
      <div className="px-5 py-4 flex justify-between items-center gap-4">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Typography variant="h6" weight="semibold" className="whitespace-nowrap">
            {title}
          </Typography>
          <Typography variant="body-xs" color="secondary" as="span" className="tabular-nums">
            {count}
          </Typography>
        </div>
        <div className="flex items-center gap-3 min-w-0">
          <SearchInput
            value={searchValue}
            onChange={onSearchChange}
            placeholder="Search members"
            showClearButton={true}
            mobileToggle={true}
          />
          {action}
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-auto bg-white shadow-sm border border-gray-200 rounded-xl mx-5 mb-5">
        <Table>
          <TableBody>{children}</TableBody>
        </Table>
      </div>
    </div>
  );
};
